import { faExchange, faPencil, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { HolidayRequestStatus, HolidayTime } from "src/app/enums/Index";
import { GetPropertiesFromEnum } from "src/app/helpers/GetPropertiesFromEnum";
import { HolidayRequest, User } from "src/app/interfaces/Index";
import { HolidayRequestService, UserService } from "src/app/services/Index";
import { colours } from "src/app/Styles";

type Props = {};
type State = {
	allowedStatuses: any;
	dropdownUsers: any;
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	holidayTimes: any;
	holidayTimesEnd: any;
	holidayTimesStart: any;
	masterItems: HolidayRequest[];
	items: HolidayRequest[];
	selectedItem: HolidayRequest;
	showDeleteModal: boolean;
	showItemInfoModal: boolean;
	showStatusChangeModal: boolean;
	statusChangeReason: string;
	statuses: any;
	submitted: boolean;
	users: User[];
};

export class AdminHolidayRequests extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Holiday Request";
	itemNamePlural: string = "Holiday Requests";

	constructor(props: Props) {
		super(props);
		this.state = {allowedStatuses: [], dropdownUsers: [], isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", holidayTimes: GetPropertiesFromEnum(HolidayTime), holidayTimesEnd: [], holidayTimesStart: [], masterItems: [], selectedItem: new HolidayRequest(), items: [], showDeleteModal: false, showItemInfoModal: false, showStatusChangeModal: false, statusChangeReason: "", statuses: GetPropertiesFromEnum(HolidayRequestStatus), submitted: false, users: []};
	}

	componentDidMount() {
		this.getItems();
		this.getUsers();

		const holidayTimesEnd = this.state.holidayTimes.filter((ht: { name: string, id: number; }) => ht.id !== HolidayTime.StartOfDay);
		const holidayTimesStart = this.state.holidayTimes.filter((ht: { name: string, id: number; }) => ht.id !== HolidayTime.EndOfDay);
		this.setState({holidayTimesEnd, holidayTimesStart});
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm() {
		this.setState({isLoading: true});
			const res = await HolidayRequestService.deleteSingleById(this.state.selectedItem.id);

			if (res.ok) {
				this.setState({isLoading: false, showDeleteModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been deleted", life: 5000, severity: "success", summary: this.itemName + " deleted!"});
				this.getItems();
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
	}

	itemInfoFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new HolidayRequest(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
		);
	}

	globalFilterChange(e: any) {
		let value = "";		
		if (e !== ""){
			value = e.target.value;
			const users = this.state.dropdownUsers.filter((u: { fullName: string, id: number; }) => u.fullName.toLowerCase().includes(value.toLowerCase()));
			
			let newData = this.state.masterItems.filter(function(item){
				let user = users.filter((u: { fullName: string, id: number; }) => u.id === item.requestedById);
				return user.length > 0;
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await HolidayRequestService.getAll();

		if (res.ok) {
			const response = await res.json();
			this.setState({isLoading: false, items: response, masterItems:response});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
	}

	async getUsers() {
		this.setState({isLoading: true});
		const res = await UserService.getAll();

		if (res.ok) {
			const response = await res.json();
			const dropdownUsers = response.map((user: User): any => ({
				id: user.id,
				fullName: `${user.firstName} ${user.lastName}`
			}));

			this.setState({isLoading: false, users: response, dropdownUsers: dropdownUsers});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new HolidayRequest({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new HolidayRequest({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	openStatusChangeModal(rowData: any) {
		let allowedStatuses = this.state.statuses;

		// Always get rid of the Pending option
		allowedStatuses.splice(0, 1);
		switch (rowData.requestStatus) {
			case HolidayRequestStatus.Approved:
				// if the holiday was already approved, it can only be revoked, so remove Approved and Declined
				allowedStatuses.splice(0, 2);
				rowData.holidayRequestStatus = HolidayRequestStatus.Revoked;
				break;
			case HolidayRequestStatus.Declined:
			case HolidayRequestStatus.Revoked:
				// if the holiday was already declined or Revoked, it can only be approved, so remove Declined and Revoked
				allowedStatuses.splice(1, 2);
				break;
			case HolidayRequestStatus.Pending:
				// if the holiday is pending, it can only be Approved or Declined, so remove Revoked
				allowedStatuses.splice(2, 1);
				break;
		}

		this.setState({allowedStatuses, selectedItem: rowData, showStatusChangeModal: true})
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							<DataTable loading={this.state.isLoading} ref={(el) => this.dt = el} scrollable scrollHeight="flex" style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items} sortField="name" sortOrder={1}>
								<Column field="requestedById" header="User" sortable body={(rowData: any) => this.renderUser(rowData.requestedById)}></Column>
								<Column field="startDate" header="Start Date" sortable body={(rowData: any) => this.renderDate(rowData.startDate)}></Column>
								<Column field="startTime" header="Start Time" body={(rowData: any) => this.renderTime(rowData.startTime)}></Column>
								<Column field="endDate" header="End Date" sortable body={(rowData: any) => this.renderDate(rowData.endDate)}></Column>
								<Column field="endTime" header="End Time" body={(rowData: any) => this.renderTime(rowData.endTime)}></Column>
								<Column field="holidayLength" header="Length (days)"></Column>
								<Column field="requestStatus" header="Status" sortable body={(rowData: any) => this.renderRequestStatus(rowData.requestStatus)}></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.buttons.edit, borderColor: colours.buttons.edit, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="Edit">
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.openStatusChangeModal(rowData)} style={{backgroundColor: colours.buttons.edit, borderColor: colours.buttons.edit, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="Change Status">
											<FontAwesomeIcon icon={faExchange} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.buttons.delete, borderColor: colours.buttons.delete, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}} title="Remove">
											<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="requestedById">User <span className="required">*</span></label>
											<Dropdown id="requestedById" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, requestedById: e.value}})} options={this.state.dropdownUsers} optionLabel="fullName" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.requestedById} disabled/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="startDate">Start Date <span className="required">*</span></label>
											<Calendar dateFormat="dd/mm/yy" id="startDate" onChange={(e) => this.inputChange(e, "startDate")} required value={new Date(this.state.selectedItem.startDate)} showButtonBar />
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="startTime">Start Time <span className="required">*</span></label>
											<Dropdown id="startTime" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, startTime: e.value}})} options={this.state.holidayTimesStart} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.startTime}/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="endDate">End Date <span className="required">*</span></label>
											<Calendar dateFormat="dd/mm/yy" id="endDate" onChange={(e) => this.inputChange(e, "endDate")} required value={new Date(this.state.selectedItem.endDate)} showButtonBar />
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="endTime">End Time <span className="required">*</span></label>
											<Dropdown id="endTime" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, endTime: e.value}})} options={this.state.holidayTimesEnd} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.endTime}/>
										</div>
									</Col>
								</Row>
							</Dialog>
							<Dialog className="p-fluid" footer={() => this.deleteItemFooter()} header={"Delete " + this.itemName} modal onHide={() => this.setState({ showDeleteModal: false })} style={{ width: "75%" }} visible={this.state.showDeleteModal}>
								<Row>
									<Col>
										Are you sure you wish to delete the selected item?
									</Col>
								</Row>
							</Dialog>
							<Dialog className="p-fluid" footer={() => this.statusChangeFooter()} header={this.itemName + " Status"} modal onHide={() => this.setState({ showStatusChangeModal: false })} style={{ width: "75%" }} visible={this.state.showStatusChangeModal}>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="requestStatus">New Status <span className="required">*</span></label>
											<Dropdown id="requestStatus" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, requestStatus: e.value}})} options={this.state.allowedStatuses} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.requestStatus}/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="endTime">Reason <span className="required">* if declined / revoked</span></label>
											<InputText id="endTime" value={this.state.statusChangeReason} onChange={(e:any) => { this.setState({statusChangeReason: e.target.value}); }}/>
										</div>
									</Col>
								</Row>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	renderDate(e: Date) {
		const date = new Date(e);
		return date.toLocaleDateString('en-GB', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});
	}

	renderLeftToolbarButtons() {
		return (
			<>
			</>
		);
	}

	renderRequestStatus(e: HolidayRequestStatus) {
		const status = this.state.statuses.filter((f: { id: any, name: string; }) => f.id === e)[0];
		return status === undefined ? "???" : status.name;
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-download" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt.exportCSV()}></Button>
			</>
		);
	}

	renderTime(e: HolidayTime) {
		const holidayTime = this.state.holidayTimes.filter((f: { id: any, name: string; }) => f.id === e)[0];
		return holidayTime === undefined ? "???" : holidayTime.name;
	}

	renderUser(e?: number) {
		if (e === undefined || e === null) {
			return "";
		}
		const user = this.state.users.filter(f => f.id === e)[0];
		return user === undefined ? "" : user.firstName + ' ' + user.lastName;
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await HolidayRequestService.createSingle(this.state.selectedItem);

			if (res.ok) {
				this.setState({isLoading: false, showItemInfoModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
		} else { // Save existing
			const res = await HolidayRequestService.updateSingleById(this.state.selectedItem.id, this.state.selectedItem);

			if (res.ok) {
				this.setState({isLoading: false, showItemInfoModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
		}
		await this.getItems();
	}

	async saveNewStatus() {
		this.setState({isLoading: true});
		const res = await HolidayRequestService.changeStatus({holidayRequestId: this.state.selectedItem.id, holidayRequestStatus: this.state.selectedItem.requestStatus, reason: this.state.statusChangeReason});

		if (res.ok) {
			this.setState({isLoading: false, showStatusChangeModal: false});
			this.toast.show({closable: false, detail: this.itemName + " has been updated", life: 5000, severity: "success", summary: this.itemName + " updated!"});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
			
		await this.getItems();
	}

	statusChangeFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new HolidayRequest(), showStatusChangeModal: false, statusChangeReason: ""})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveNewStatus()}></Button>
			</>
		);
	}
}